/**
 * alarmMsg 값을 저장하는 util
 */
import { show } from '@/components/Dialogs/DialogUtils';
import router from '@/router';

/**
 * Show Alert Dialog
 * @param {string} msg 메시지
 * @param {string} title 헤더 타이틀
 * @param {string} confirmBtnText 확인버튼 레이블
 * @returns
 */
const showMsg = (msg, title, confirmBtnText = '확인', { zIndex } = {}) => {
	if (typeof msg === 'object') {
		const { msg: _msg, title: _title, confirmBtnText: _confirmBtnText, ..._rest } = msg;
		return showMsg(_msg, _title, _confirmBtnText, _rest);
	}
	return show({
		title: title || '알림',
		text: '<span class="tmbox">' + msg + '</span>',
		buttons: [
			{
				title: confirmBtnText,
				type: 'primary',
				value: true,
			},
		],
		zIndex,
	});
};

/**
 * Show Confirm Dialog
 * @param {string} msg 메시지
 * @param {string} title 헤더 타이틀
 * @param {string} confirmBtnText 확인버튼 레이블
 * @param {string} cancelBtnText 취소버튼 레이블
 * @returns
 */
const showConfirm = (msg, title, confirmBtnText = '확인', cancelBtnText = '취소') => {
	return show({
		title: title || '확인',
		text: '<span class="tmbox">' + msg + '</span>',
		buttons: [
			{
				title: cancelBtnText,
				type: 'default',
				// value가 없을 경우 reject 됨
				// value: false,
			},
			{
				title: confirmBtnText,
				type: 'primary',
				value: true,
			},
		],
	});
};

/**
 * Show Confirm Dialog
 * @description
 * 기본적으로 showConfirm와 동일하나,
 * 취소시 Error를 throw하지 않고 Promise<false>를 반환
 * @param {string} msg 메시지
 * @param {string} title 헤더 타이틀
 * @param {string} confirmBtnText 확인버튼 레이블
 * @param {string} cancelBtnText 취소버튼 레이블
 * @returns
 */
const showSafetyConfirm = (msg, title, confirmBtnText = '확인', cancelBtnText = '취소') => {
	return show({
		title: title || '확인',
		text: '<span class="tmbox">' + msg + '</span>',
		buttons: [
			{
				title: cancelBtnText,
				type: 'default',
				value: false,
			},
			{
				title: confirmBtnText,
				type: 'primary',
				value: true,
			},
		],
	});
};

export default {
	getMsg: response => {
		let eventCd = response.code;
		/* 오류 메세지 모음 */
		let alarmMsg = '';
		let alarmTitle = '안내';
		let alarmType = '1'; // 1 : alert, 2 : confirm

		let confirmBtn = '확인';
		let cancelBtn = '취소';
		let confirmFunc = function () {};
		let cancelFunc = function () {};

		/* 공통 */
		if (eventCd === 'ERR0000') {
			alarmMsg = '<span class="tmbox">오류가 발생하였습니다. 관리자에게 문의 해주세요.</span>';
		} else if (eventCd === 'ERR0001') {
			alarmMsg = '<span class="tmbox">파라미터가 잘못되었거나 요청문이 잘못되었습니다.</span>';
		} else if (eventCd === 'ERR0002') {
			alarmMsg = '<span class="tmbox">인증 헤더(authorization header)가 없습니다.</span>';
			// } else if (eventCd === 'ERR0003') {
			//   alarmMsg = '<span class="tmbox">토큰키가 유효하지 않습니다.</span>'
			// } else if (eventCd === 'ERR0004') {
			//   alarmMsg = '<span class="tmbox">토큰키가 만료되었습니다.</span>'
		} else if (eventCd === 'ERR0005') {
			alarmMsg = '<span class="tmbox">인증에 실패했습니다.</span>';
		} else if (eventCd === 'ERR0006') {
			alarmMsg = '<span class="tmbox">파일 업로드 사이즈 오류 입니다.</span>';
		} else if (eventCd === 'ERR0007') {
			alarmMsg = '<span class="tmbox">인증 서버의 오류로 요청을 처리하지 못했습니다.</span>';
		} else if (eventCd === 'ERR0008') {
			alarmMsg = '<span class="tmbox">SQL 실행 오류 입니다.</span>';
		} else if (eventCd === 'ERR0100') {
			/* 회원 관련 */
			alarmMsg = '<span class="tmbox">사업자 등록 번호 조회 실패입니다.</span>';
		} else if (eventCd === 'ERR0101') {
			alarmMsg = '<span class="tmbox">이메일 인증 발송 실패 입니다.</span>';
		} else if (eventCd === 'ERR0102') {
			alarmMsg = '<span class="tmbox">이메일 인증 요청 실패 입니다.</span>';
		} else if (eventCd === 'ERR0103') {
			alarmMsg = '<span class="tmbox">이메일 인증 키가 만료되었습니다.</span>';
		} else if (eventCd === 'ERR0104') {
			alarmMsg = '<span class="tmbox">이메일 인증을 이미 받았습니다.</span>';
		} else if (eventCd === 'ERR0105') {
			alarmMsg = '<span class="tmbox">이메일 인증 키가 서버 내에 존재하지 않습니다.</span>';
		} else if (eventCd === 'ERR0106') {
			alarmMsg = '<span class="tmbox">이미 가입된 이메일입니다.<br>이메일을 다시 입력해주세요.</span>';
		} else if (eventCd === 'ERR0107') {
			alarmMsg = '<span class="tmbox">아이디 이메일 인증을 해주세요.</span>';
		} else if (eventCd === 'ERR0108') {
			alarmMsg = '<span class="tmbox">첨부파일 등록 중 에러가 발생했습니다.</span>';
		} else if (eventCd === 'ERR0109') {
			alarmMsg = '<span class="tmbox">해당 휴대폰 번호는 휴대폰 인증을 이미 했습니다.</span>';
		} else if (eventCd === 'ERR0110') {
			alarmMsg = '<span class="tmbox">이메일 중복입니다.</span>';
		} else if (eventCd === 'ERR0111' || eventCd === 'ERR0121') {
			alarmMsg =
				'<span class="tmbox">고객님의 개인정보보호를 위해 비밀번호 초기화되었습니다.<br>' +
				'<strong>비밀번호 찾기를 통해 본인인증 후 새로운 비밀번호로 변경해주세요.</span>';
			alarmTitle = '로그인 5회 실패';
			alarmType = '2';
			confirmBtn = '비밀번호 찾기';
			confirmFunc = function () {
				router.push('/Findpwd');
			};
		} else if (eventCd === 'ERR0112') {
			alarmMsg =
				'<span class="tmbox">회원님의 요청으로 잠금 처리 된 계정입니다.<br>계정 잠금 해제는 1:1문의 또는 고객센터(1588-0108)으로 문의해주세요.</span>';
		} else if (eventCd === 'ERR0113') {
			alarmMsg =
				'<span class="tmbox">회원가입 시 등록한 사업자 정보를 확인 중입니다.<br>관리자 승인 완료 후 로그인 가능합니다.</span>';
		} else if (eventCd === 'ERR0114') {
			alarmMsg = '<span class="tmbox">인증받지 않은 인증 코드(authorization code)로 요청했습니다.</span>';
		} else if (eventCd === 'ERR0115') {
			alarmMsg =
				'<span class="tmbox">등록되지 않은 아이디이거나 아이디 또는 비밀번호를 잘못 입력하셨습니다.<br/>회원님의 아이디와 비밀번호를 정확하게 다시 입력해주세요.</span>';
		} else if (eventCd === 'ERR0116') {
			alarmMsg = '<span class="tmbox">사용자 방문 일수가 90일을 넘었습니다.</span>';
		} else if (eventCd === 'ERR0117') {
			alarmMsg =
				'<span class="tmbox">' +
				'	등록되지 않은 아이디이거나 아이디 또는 비밀번호를 잘못 입력하셨습니다.<br>' +
				'	회원님의 아이디와 비밀번호를 정확하게 다시 입력해주세요.<br>' +
				'	(로그인 5회 중 ' +
				response.result.loginFailCnt +
				'회 실패)' +
				'</span>';
		} else if (eventCd === 'ERR0118') {
			alarmMsg = '<span class="tmbox">비밀번호가 틀렸습니다.</span>';
		} else if (eventCd === 'ERR0119') {
			alarmMsg = '<span class="tmbox">MBS 발송 실패 입니다.</span>';
		} else if (eventCd === 'ERR0122') {
			alarmMsg =
				'<span class="tmbox">탈퇴 계정으로 로그인 불가합니다. 자세한 사항은 1:1문의 또는 고객센터(1588-0108)로 문의해주세요.</span>';
		} else if (eventCd === 'ERR0124') {
			alarmMsg =
				'<span class="tmbox">회원님의 계정은 현재 이용중지 상태입니다.<br/>서비스 이용 관련 문의는 1:1문의를 이용해 주세요.</span>';
		} else if (eventCd === 'ERR0125') {
			alarmMsg = '<span class="tmbox">사용자 사용 상태를 알수 없습니다.</span>';
		} else if (eventCd === 'ERR0126') {
			alarmMsg = '<span class="tmbox">휴대폰 인증 정보가 없습니다.</span>';
		} else if (eventCd === 'ERR0127') {
			alarmMsg = '<span class="tmbox">인증번호가 일치하지 않습니다.<br>인증번호를 다시 확인 후 입력해주세요.</span>';
		} else if (eventCd === 'ERR0128') {
			alarmMsg = '<span class="tmbox">휴대폰 인증 기한이 만료 되었습니다.</span>';
		} else if (eventCd === 'ERR0129') {
			alarmMsg = '<span class="tmbox">비밀번호 변경 기한이 만료되었습니다.</span>';
		} else if (eventCd === 'ERR0130') {
			alarmMsg = '<span class="tmbox">현재 비밀번호를 다시 확인해주세요.</span>';
		} else if (eventCd === 'ERR0131') {
			alarmMsg = '<span class="tmbox">비밀번호 변경 기한이 만료되었습니다.</span>';
		} else if (eventCd === 'ERR0406') {
			alarmMsg = '<span class="tmbox">휴대전화번호 인증정보가 잘못되어 본인인증에 실패하였습니다.</span>';
		} else {
			//alarmMsg = '<span class="tmbox">' + (response.msg === (null || undefined) ? '오류가 발생했습니다.' : response.msg) + ' - ' + eventCd + '</span>'
		}

		if (alarmType === '1') {
			showMsg(alarmMsg, alarmTitle);
		} else if (alarmType === '2') {
			showConfirm(alarmMsg, alarmTitle, confirmBtn, cancelBtn)
				.then(function () {
					confirmFunc();
				})
				.catch(function () {
					cancelFunc();
				});
		}

		/* return {
			'msg'		: alarmMsg,
			'title'	: alarmTitle,
			'type'	:	alarmType
		} */
	},
	/* 회원가입 */
	getJoinMsg: eventCd => {
		var alarmMsg = '';
		var alarmTitle = '안내';
		var alarmType = '1'; // 1 : alert, 2 : confirm

		var confirmBtn = '확인';
		var cancelBtn = '취소';
		var confirmFunc = function () {};
		var cancelFunc = function () {};

		if (eventCd === 'sucBizNo') {
			alarmMsg =
				'<span class="tmbox">사업자 인증이 완료되었습니다.<br/>회원정보 입력 후 가입 완료 시 이마트 상품권 5천원 + 비즈할인권 5천원 증정 혜택을 드립니다.(마케팅 수신 동의 시)</span>';
		} else if (eventCd === 'unknownBiz') {
			alarmMsg =
				'<span class="tmbox">사업자등록번호가 확인되지 않습니다.<br>' +
				'	사업자 인증이 안되는 경우 PC에서 회원가입이 가능하며,<br>' +
				' 관리자 승인 후 서비스 이용 가능합니다</span>';
		} else if (eventCd === 'closedBiz') {
			alarmMsg =
				'<span class="tmbox">' +
				'	휴업/폐업 상태인 사업자로 확인됩니다.<br>' +
				'	기프티쇼 비즈는 영업 중인 사업자만 가입 가능합니다.' +
				'</span>';
		} else if (eventCd === 'discordBiz') {
			alarmMsg =
				'<span class="tmbox">' +
				'	상호명과 사업자 등록번호가 일치하지 않습니다.<br>' +
				'	사업자 정보 확인 후 재시도 바랍니다.' +
				'</span>';
		} else if (eventCd === 'sendEmail') {
			alarmMsg =
				'<span class="tmbox">' +
				// '	회원님의 이메일로 인증 URL이 전송되었습니다.<br>' +
				// '	10분 이내에 인증 URL을 클릭하여 인증을 완료해주세요.<br>' +
				// '	(이메일 도착까지 최대 5분 정도 소요됩니다.)' +
				'이메일(아이디) 인증이 완료되었습니다.' +
				'</span>';
		} else if (eventCd === 'timeOutIdEmailAuth') {
			alarmMsg = '<span class="tmbox">이메일 인증 유효시간이 종료되었습니다.<br>다시 인증해주세요.</span>';
		} else if (eventCd === 'noChkBizNo') {
			alarmMsg = '<span class="tmbox">사업자인증을 진행해주세요.</span>';
		} else if (eventCd === 'noChkIdEmail') {
			alarmMsg = '<span class="tmbox">아이디 이메일 인증을 해주세요.</span>';
		} else if (eventCd === 'noChkPw') {
			alarmMsg = '<span class="tmbox">비밀번호를 다시 확인해주세요.</span>';
		} else if (eventCd === 'noSelBiz') {
			alarmMsg = '<span class="tmbox">업태를 선택해주세요.</span>';
		} else if (eventCd === 'noSelIds') {
			alarmMsg = '<span class="tmbox">업종을 선택해주세요.</span>';
		} else if (eventCd === 'noInputPw') {
			alarmMsg = '<span class="tmbox">비밀번호를 입력해주세요.</span>';
		} else if (eventCd === 'noInputRepNm') {
			alarmMsg = '<span class="tmbox">대표자 이름을 입력해주세요.</span>';
		} else if (eventCd === 'noInputuserName') {
			alarmMsg = '<span class="tmbox">휴대전화번호 인증후 담당자 이름을 확인해주세요.</span>';
		} else if (eventCd === 'noInputTelNo') {
			alarmMsg = '<span class="tmbox">유선전화번호를 입력해주세요.</span>';
		} else if (eventCd === 'noChkMobile') {
			alarmMsg = '<span class="tmbox">휴대폰 본인인증을 해주세요.</span>';
		} else if (eventCd === 'noInputEmail') {
			alarmMsg = '<span class="tmbox">이메일을 입력해주세요.</span>';
		} else if (eventCd === 'noChkEmailForm') {
			alarmMsg = '<span class="tmbox">이메일 형식이 잘못되었습니다. 다시 확인 후 입력해주세요.</span>';
		} else if (eventCd === 'chkReqTerms') {
			alarmMsg = '<span class="tmbox">필수 약관에 모두 동의해주세요.</span>';
		} else if (eventCd === 'chkReqBizNm') {
			alarmMsg = '<span class="tmbox">상호명을 입력해주세요.</span>';
		} else if (eventCd === 'rollByAuth') {
			alarmMsg =
				'<span class="tmbox">인증번호 입력 시간이 경과하였습니다. 인증번호 재전송 후 다시 입력해주세요.</span>';
		} else if (eventCd === 'noInpBizNo') {
			alarmMsg = '<span class="tmbox">사업자등록번호를 입력해주세요.</span>';
		} else if (eventCd === 'noUpBizFile') {
			alarmMsg = '<span class="tmbox">사업자등록증사본을 업로드해주세요.</span>';
		} else if (eventCd === 'chkBizFile') {
			alarmMsg = '<span class="tmbox">사업자등록증사본의 파일 양식 또는 용량을 다시 확인해주세요.</span>';
		} else if (eventCd === 'joinCancel') {
			alarmMsg =
				'<span class="tmbox">취소 시 입력하신 정보는 저장되지 않습니다.<br>' +
				'	회원가입을 취소하고 메인페이지로 가시겠습니까?</span>';
			alarmTitle = '회원가입 취소';
			alarmType = '2';
			confirmBtn = '예';
			cancelBtn = '아니오';
			confirmFunc = function () {
				router.replace('/');
			};
			/* cancelFunc = (function(){  }) */
		} else if (eventCd === 'noSelDm') {
			alarmMsg = '<span class="tmbox">근무부서를 선택해주세요.</span>';
		} else if (eventCd === 'noSelPt') {
			alarmMsg = '<span class="tmbox">직책을 선택해주세요.</span>';
		} else if (eventCd === 'noSelIfo') {
			alarmMsg = '<span class="tmbox">유입경로를 선택해주세요.</span>';
		} else if (eventCd === 'noIpIfo') {
			alarmMsg = '<span class="tmbox">유입경로를 입력해주세요.</span>';
		} else if (eventCd === 'noSelPco') {
			alarmMsg = '<span class="tmbox">구매목적을 선택해주세요.</span>';
		} else if (eventCd === 'noIpPco') {
			alarmMsg = '<span class="tmbox">구매목적을 입력해주세요.</span>';
		} else {
			alarmMsg = '<span class="tmbox">관리자에게 문의바랍니다.</span>';
		}

		if (alarmType === '2') {
			showConfirm(alarmMsg, alarmTitle, confirmBtn, cancelBtn)
				.then(function () {
					confirmFunc();
				})
				.catch(function () {
					cancelFunc();
				});
		} else {
			showMsg(alarmMsg, alarmTitle);
		}
	},
	/* 회원 */
	getUserMsg: eventCd => {
		let alarmMsg = '';
		let alarmTitle = '안내';
		let alarmType = '1'; // 1 : alert, 2 : confirm

		let confirmBtn = '확인';
		let cancelBtn = '취소';
		let confirmFunc = function () {};
		let cancelFunc = function () {};

		if (eventCd === 'sucChgPwd') {
			alarmMsg = '<span class="tmbox">비밀번호 재설정이 완료되었습니다.<br>새 비밀번호로 로그인해주세요.</span>';
			alarmTitle = '비밀번호 재설정 완료';
		} else {
			alarmMsg = '<span class="tmbox">관리자에게 문의바랍니다.</span>';
		}

		if (alarmType === '2') {
			showConfirm(alarmMsg, alarmTitle, confirmBtn, cancelBtn)
				.then(function () {
					confirmFunc();
				})
				.catch(function () {
					cancelFunc();
				});
		} else {
			showMsg(alarmMsg, alarmTitle);
		}
	},
	// alert 문구
	validationMsg: (type, title) => {
		let alarmMsg = '';

		let alarmTitle = title || '안내';
		switch (type) {
			case 'noInputSearch':
				alarmMsg = '<span class="tmbox">검색어를 입력해주세요.</span>';
				break;
			case 'limit2charSearch':
				alarmMsg = '<span class="tmbox">검색어는 최소 2글자를 입력해주세요.</span>';
				break;
			case 'completeFlag':
				alarmMsg = '<span class="tmbox">이미 참여하신 이벤트입니다.</span>';
				break;
			case 'reportNull':
				alarmMsg = '<span class="tmbox">답변하지 않은 문항이 있습니다. 답변을 완료해주세요.</span>';
				break;
			case 'reportEtcNull':
				alarmMsg = '<span class="tmbox">기타 의견을 작성해주세요.</span>';
				break;
			case 'reportSubmit':
				alarmMsg = '<span class="tmbox">회원님의 소중한 의견이 전달되었습니다. 감사합니다.</span>';
				break;
			case 'nullData':
				alarmMsg = '<span class="tmbox">데이터가 잘못되어 이전페이지로 이동합니다.</span>';
				break;
			case 'noEvent':
				alarmMsg = '<span class="tmbox">풍성한 혜택으로 곧 찾아 뵙겠습니다.</span>';
				break;
			case 'smsOk':
				alarmMsg = '<span class="tmbox">휴대전화번호 인증에 성공하였습니다.</span>';
				break;
			case 'noNmInput':
				alarmMsg = '<span class="tmbox">별칭을 입력해주세요.</span>';
				break;
			case 'noSmsOk':
				alarmMsg = '<span class="tmbox">휴대전화번호 인증을 확인해주세요.</span>';
				break;
			case 'successFwNbMng':
				alarmMsg = '<span class="tmbox">발송번호 등록이 완료되었습니다.</span>';
				break;
			case 'successSvcFwNbMng':
				alarmMsg =
					'<span class="tmbox">발송번호 접수가 완료되었습니다. 영업일 기준 1일<br>이내 승인 완료 처리 됩니다.</span>';
				break;
			case 'myBizFwNbCsNumber':
				alarmMsg = '<span class="tmbox">고객센터 발신번호는 삭제하실수 없습니다.</span>';
				break;
			case 'myBizFwNbDefaultNumberDel':
				alarmMsg =
					'<span class="tmbox">기본 발신번호로 설정된 발신번호는 삭제하실 수 없습니다. <br>기본 발신번호 변경 후 삭제해주세요.</span>';
				break;
			case 'myBizFwNbNullFile':
				alarmMsg = '<span class="tmbox">통신가입 사실/이용 증명원을 업로드해주세요.</span>';
				break;
			case 'myBizFwNbOverSizeFile':
				alarmMsg = '<span class="tmbox">잘못된 파일입니다. PDF, JPG, PNG로 2MB 이하로<br>등록 가능합니다.</span>';
				break;
			case 'txtmsgmngTitleNull':
				alarmMsg = '<span class="tmbox">MY 메시지 제목을 입력해주세요.</span>';
				break;
			case 'txtmsgmngTxtNull':
				alarmMsg = '<span class="tmbox">MY 메시지 내용을 입력해주세요</span>';
				break;
			case 'spcCheck':
				alarmMsg =
					'<span class="tmbox">“‘, $, &, *, |, , }, ], {, [, “, ‘, <, >, ㈜, →, ≥, ≡, ℡, ≒, ∃, ⊙, ㉿, √, ∬, ⊥, ≠, ¿, ↗, ™, §, ∽, ±, ↙, ∞, ≤, ∂, ∴ 특수문자는 입력하실 수 없습니다.</span>';
				break;
			case 'msgMngFileType':
				alarmMsg = '<span class="tmbox">배너/카드 이미지 등록은 JPEG, PNG만 등록 가능합니다.</span>';
				break;
			case 'msgMngFileBannerSize':
				alarmMsg = '<span class="tmbox">배너 등록 사이즈는 700X280px 입니다. 이미지<br>파일을 확인해주세요.</span>';
				break;
			case 'msgMngFileCardSize':
				alarmMsg = '<span class="tmbox">배너 등록 사이즈는 330X330px 입니다. 이미지<br>파일을 확인해주세요.</span>';
				break;
			case 'msgMngFileOver':
				alarmMsg =
					'<span class="tmbox">배너/카드 등록 최대 용량은 500KB를 초과할 수<br>없습니다. 이미지 파일을 확인해주세요.</span>';
				break;
			case 'msgMngImgNoSelect':
				alarmMsg = '<span class="tmbox">이미지를 선택해주세요.</span>';
				break;
			case 'msgMngImgAdd':
				alarmMsg = '<span class="tmbox">기본 이미지로 저장되었습니다.</span>';
				break;
			case 'memberUpdate':
				alarmMsg = '<span class="tmbox">회원정보 변경이 완료되었습니다.</span>';
				break;
		}
		showMsg(alarmMsg, alarmTitle);
	},

	showMsg,
	showConfirm,
	showSafetyConfirm,
};
